import { NumberFieldWithFlexibility } from '~/components/common/form/NumberFieldWithFlexibility/NumberFieldWithFlexibility';

export const WeddingPartyField = () => (
  <NumberFieldWithFlexibility
    label="Total estimate"
    placeholder="Enter a number"
    name="weddingPartyCount"
    required={false}
    stillDecidingFieldName="stillDecidingOnWeddingParty"
    flexibleFieldName="flexibleOnWeddingPartyCount"
  />
);
